import type { NotificationStatus } from './notification';

export const READ_STATUSES: NotificationStatus[] = ['read', 'archived'];
